/**
 * 캠페인 연결 규칙(rule-engine) API.
 *
 * 배경: 조건 / 규칙 그룹 / 캠페인 규칙셋은 각각 Manage·Form·Modal·Detail·SearchModal
 * 5종 세트를 갖고 있고, 그 안에서 `this.$axios.get('/rule-engine/...')` 를 직접
 * 호출한다. 같은 엔드포인트가 여러 컴포넌트에 흩어져 있어 경로/파라미터가 바뀔 때
 * 전부 찾아 고쳐야 하고, 설정 마법사처럼 **컴포넌트를 재사용하지 않는 새 화면**을
 * 만들면 호출이 또 복붙된다.
 *
 * 여기로 모아 호출부가 엔드포인트 문자열을 몰라도 되게 한다.
 *
 * 시그니처: 두 번째 인자는 **axios 요청 config 그대로**(`{params: {...}}`) 받는다.
 * 기존 호출부가 `this.$axios.get(url, {params})` 형태라 이 모양이어야 엔드포인트
 * 문자열만 걷어내는 **기계적 치환**이 되고, 마이그레이션 중 의미가 바뀌지 않는다.
 *
 * 인스턴스: `createApiInstance()` 는 `Vue.prototype.$axios` 와 동일한 팩토리
 * 호출이라(플러그인 `packages/core/plugins/axios.js` 참고) 인증 헤더·토큰 갱신
 * 인터셉터가 그대로 적용된다.
 */
import createApiInstance from '@core/utils/api/custom.instance';

const api = createApiInstance();

// ── 조건 (Condition) ──────────────────────────────

export const listConditions = (config) => api.get('/rule-engine/conditions', config);
export const getCondition = (conditionId) => api.get(`/rule-engine/conditions/${conditionId}`);
export const createCondition = (body) => api.post('/rule-engine/conditions', body);
export const updateCondition = (conditionId, body) => api.put(`/rule-engine/conditions/${conditionId}`, body);
export const deleteCondition = (conditionId) => api.delete(`/rule-engine/conditions/${conditionId}`);

// ── 규칙 그룹 (RuleGroup) ─────────────────────────

export const listRuleGroups = (config) => api.get('/rule-engine/rule-groups', config);
export const getRuleGroup = (ruleGroupId) => api.get(`/rule-engine/rule-groups/${ruleGroupId}`);
export const createRuleGroup = (body) => api.post('/rule-engine/rule-groups', body);
export const updateRuleGroup = (ruleGroupId, body) => api.put(`/rule-engine/rule-groups/${ruleGroupId}`, body);
export const deleteRuleGroup = (ruleGroupId) => api.delete(`/rule-engine/rule-groups/${ruleGroupId}`);

// ── 캠페인 규칙셋 (CampaignRuleSet) ───────────────

export const listCampaignRuleSets = (config) => api.get('/rule-engine/campaign-rule-sets', config);
export const getCampaignRuleSet = (ruleSetId) => api.get(`/rule-engine/campaign-rule-sets/${ruleSetId}`);
export const createCampaignRuleSet = (body) => api.post('/rule-engine/campaign-rule-sets', body);
export const updateCampaignRuleSet = (ruleSetId, body) => api.put(`/rule-engine/campaign-rule-sets/${ruleSetId}`, body);
export const deleteCampaignRuleSet = (ruleSetId) => api.delete(`/rule-engine/campaign-rule-sets/${ruleSetId}`);

// ── 평가 ──────────────────────────────────────────

/**
 * 사용자 입력으로 매칭되는 캠페인을 찾는다.
 * `user_inputs` 가 비어 있으면 백엔드가 400 을 낸다 — 호출 전에 확인할 것.
 */
export const matchCampaign = (body) => api.post('/rule-engine/evaluate/match-campaign', body);
